export default () => `
  query {
    checkout {
      applePay {
        isAvailable
        checkoutRequest
        authorizePaymentUrl
      }
    }
    paths {
      authorizeMerchantsUrl
      termsAndConditionsUrl
    }
  }
`
